import React, {useRef, useEffect} from 'react'
import { PerspectiveCamera } from '@react-three/drei'
import { OrthographicCamera } from '@react-three/drei'
import { useThree } from '@react-three/fiber'
import { useDispatch, useSelector } from 'react-redux'
import {handleExportedImages, handleExportFunctionActivated} from "../Redux/UIMenus/uiExportMenuSlice"
import { E_MainLato } from './Utils/enumerations'

export default function Cameras() {    
    const exportFunctionActivation = useSelector(state => state.uiExportMenu.exportFunctionActivated);
    
    const lunghezzaPedana = useSelector(state => state.uiMainMenu.lunghezza);
    const larghezzaPedana = useSelector(state => state.uiMainMenu.larghezza);  
    const posizioneOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.latoOmbrelloni);
    const posizioneIngresso = useSelector(state => state.uiMainMenu.ingresso);

    const orto1 = useRef();
    const orto2 = useRef();
    const orto3 = useRef();
    const orto4 = useRef();
    const ortoTop = useRef();
    const defaultCamera = useRef();
    
    const offsetCamera = 2;
    const cameraZoom = larghezzaPedana * 1 >= lunghezzaPedana * 1 ? (larghezzaPedana / larghezzaPedana) * 100 : (lunghezzaPedana / lunghezzaPedana) * 100;
    const topCameraRotation = larghezzaPedana * 1 >= lunghezzaPedana * 1 ? [-Math.PI/2, 0, Math.PI/2] : [-Math.PI/2, 0, 0];
    
    const {gl} = useThree();  
    let scene = useThree(state => state.scene); 
    
    const dispatch = useDispatch();
    
    // Genera le immagini con le viste dalle varie angolazioni da inserire nel PDF finale
    const generateCameraImages = () => {  
        // Sceglie la posizione più adatta    
        let frontCamera = null;
        let sideCamera = null;
        if (posizioneOmbrelloni.toString() !== E_MainLato.Scegli.toString()) {
            switch(posizioneOmbrelloni.toString()) {
                case E_MainLato.Lato1.toString(): 
                    frontCamera = orto3;
                    if (posizioneIngresso.toString() === E_MainLato.Lato4.toString())
                        sideCamera = orto4;
                    else
                        sideCamera = orto2;                    
                break;
                case E_MainLato.Lato2.toString(): 
                    frontCamera = orto4;
                    if (posizioneIngresso.toString() === E_MainLato.Lato3.toString())
                        sideCamera = orto3;
                    else
                        sideCamera = orto1;                
                break;
                case E_MainLato.Lato3.toString(): 
                    frontCamera = orto1;
                    if (posizioneIngresso.toString() === E_MainLato.Lato4.toString())
                        sideCamera = orto4;
                    else
                        sideCamera = orto2;                
                break;
                case E_MainLato.Lato4.toString(): 
                    frontCamera = orto2;
                    if (posizioneIngresso.toString() === E_MainLato.Lato3.toString())
                        sideCamera = orto3;
                    else
                        sideCamera = orto1;                
                break;     
                default: 
                    frontCamera = orto3;
                    if (posizioneIngresso.toString() === E_MainLato.Lato4.toString())
                        sideCamera = orto4;
                    else
                        sideCamera = orto2;                   
                break;       
            }
        } else {
            frontCamera = orto1;
            sideCamera = orto2;
        }      
        const imagesArray = [];
        imagesArray.push(exportImageView(ortoTop.current));
        imagesArray.push(exportImageView(frontCamera.current));
        imagesArray.push(exportImageView(sideCamera.current));
        imagesArray.push(exportImageView(defaultCamera.current));
        dispatch(handleExportedImages(imagesArray));       
        // Segnala la fine della generazione immagini
        dispatch(handleExportFunctionActivated(false));    
    }
    
    // Esporta le immagini generate
    const exportImageView = (actualCamera) => {       
        // Generate image
        var TDimg = new Image();     
        gl.render(scene, actualCamera);  
        TDimg.width = window.innerWidth/5;
        TDimg.height = window.innerHeight/5;     
        TDimg.src = gl.domElement.toDataURL(); 
        //var w = window.open('','_blank');
        //w.document.title = "Screenshot";
        //w.document.body.appendChild(TDimg);     
        // Esporta le immagini     
        return {
            width: TDimg.width,
            height: TDimg.height,
            src: TDimg.src, 
        };            
    }

    // Attiva la generazione delle immagini
    useEffect(() => {     
        if (exportFunctionActivation === true) {
            generateCameraImages();
        }
    }, [exportFunctionActivation]);   

    return (
        <group>
            <PerspectiveCamera makeDefault position={[6,6,6]} ref={defaultCamera}/> 
            <OrthographicCamera position={[0, 10, 0]} zoom={cameraZoom} rotation={topCameraRotation} ref={ortoTop}/>
            <OrthographicCamera position={[-lunghezzaPedana - offsetCamera, 1, 0]} zoom={cameraZoom} rotation={[0, -Math.PI/2, 0]} ref={orto1}/>
            <OrthographicCamera position={[0, 1, -larghezzaPedana/2 - offsetCamera]} rotation={[-Math.PI, 0, -Math.PI]} zoom={cameraZoom} ref={orto2}/>
            <OrthographicCamera position={[lunghezzaPedana + offsetCamera, 1, 0]} zoom={cameraZoom} rotation={[0, Math.PI/2, 0]} ref={orto3}/>
            <OrthographicCamera position={[0, 1, larghezzaPedana/2 + offsetCamera]} rotation={[0, 0, 0]} zoom={cameraZoom} ref={orto4}/>
        </group>
    )
}